import * as tslib_1 from "tslib";
import { Query } from '@datorama/akita';
import { PageStore } from './page.store';
import * as i0 from "@angular/core";
import * as i1 from "./page.store";
var PageQuery = /** @class */ (function (_super) {
    tslib_1.__extends(PageQuery, _super);
    function PageQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        _this.loading$ = _this.select(function (_a) {
            var loadersCount = _a.loadersCount;
            return loadersCount > 0;
        });
        return _this;
    }
    PageQuery.ngInjectableDef = i0.defineInjectable({ factory: function PageQuery_Factory() { return new PageQuery(i0.inject(i1.PageStore)); }, token: PageQuery, providedIn: "root" });
    return PageQuery;
}(Query));
export { PageQuery };
